export function validateEmail(email) {
  if (!email) {
    return false;
  } else if (!/\S+@\S+\.\S+/.test(email)) {
    return false;
  }
  return true;
}
